@if (isNewPage) {
  <div class="row">
    <div class="col">
      <div class="edit-menu-item-icon">
        <span class="fa-solid fa-folder"></span>
      </div>
      <span [innerText]="enteredName"></span>
    </div>
  </div>
}

<form [formGroup]="addNodeForm" class="edit-menu-form" action="">
  <div class="form-group">
    <label for="nodeName">
      <span translate>Node name</span>
      <scitis-required-field-indicator></scitis-required-field-indicator>
    </label>
    <input [ngClass]="{ 'is-invalid': submitted && addNodeForm.controls.nodeName.errors }" class="form-control"
      formControlName="nodeName" id="nodeName" (focusout)="onUpdateName()"
      type="text">
      @if (submitted && addNodeForm.controls.nodeName.errors) {
        <div class="invalid-feedback">
          @if (addNodeForm.controls.nodeName.errors.required) {
            <span translate>Node name required</span>
          }
        </div>
      }
      @if (hasDuplicates) {
        <div class="text-danger">
          <span translate>This node name already exists!</span>
        </div>
      }
    </div>
    <div class="d-flex">
      <button type="button" (click)="onSaveNode()" class="btn btn-primary" [disabled]="isSavePageButtonDisabled || hasDuplicates">
        <span translate>Save node</span>
      </button>
      <button type="button" (click)="onCancelSaveNode()" class="btn btn-link" translate>Cancel</button>
    </div>
  </form>